import { Box } from '@mui/material';
import { TextArea } from 'framework/form';
import InterruptionFormSection from '../../shared/InterruptionFormSection';
import RecipientSelectField from '../../shared/inputs/RecipientSelectField';
import { INTERRUPTION_CREATE_FORM_SX } from '../formStyles';

const InterruptionCreateFields = () => (
  <Box sx={INTERRUPTION_CREATE_FORM_SX}>
    <InterruptionFormSection
      step={1}
      title="Select recipient"
      description="Start typing at least 3 symbols to search users"
    >
      <RecipientSelectField />
    </InterruptionFormSection>
    <InterruptionFormSection step={2} title="What task status do you need?">
      <TextArea source="message" label="" placeholder="Describe the status update you need" rows={3} />
    </InterruptionFormSection>
  </Box>
);

export default InterruptionCreateFields;
